export enum SocialLoginTypeEnum {
  Google = 'google',
  EntraID = 'entraid',
}
